/**
 * FilePanel Component
 * 
 * Wrapper für den FileBrowser, der in EditorView als Tab neben "Aufgaben" angezeigt wird.
 * Nur für Projekte mit version: "2.0"!
 */

import React from 'react';
import { FileBrowser } from './FileBrowser';
import { FileDefinition } from '../../features/filesystem';
import './FileBrowser.css';

interface FilePanelProps {
  projectId: string;
  files: FileDefinition[];
  activeFile?: string;
  onFileSelect: (file: FileDefinition) => void;
  onFileCreate?: (filename: string) => void;
  onFileDelete?: (file: FileDefinition) => void;
  onFileUpload?: (file: File) => void;
  onProjectDownload?: () => void;
}

export const FilePanel: React.FC<FilePanelProps> = ({
  projectId,
  files,
  activeFile,
  onFileSelect,
  onFileCreate,
  onFileDelete,
  onFileUpload,
  onProjectDownload
}) => {
  return (
    <div className="file-panel" style={{ height: '100%', overflow: 'hidden' }}>
      <FileBrowser
        projectId={projectId}
        files={files}
        activeFile={activeFile}
        onFileSelect={onFileSelect}
        onFileCreate={onFileCreate}
        onFileDelete={onFileDelete}
        onFileUpload={onFileUpload}
        onProjectDownload={onProjectDownload}
      />
    </div>
  );
};

export default FilePanel;

